import * as Popover from '@radix-ui/react-popover';
import { Check, ChevronDown, ListFilter } from 'lucide-react';
import { StatusFilter } from '../types';
import styles from './templates-toolbar.module.css';

export interface StatusFilterOption {
  value: StatusFilter;
  label: string;
}

interface StatusFilterMenuProps {
  value: StatusFilter;
  counts: Record<StatusFilter, number>;
  onChange: (value: StatusFilter) => void;
  /** Defaults to the automations set (All/Active/Available/Draft). Segments omit "Available". */
  options?: StatusFilterOption[];
}

const DEFAULT_STATUS_OPTIONS: StatusFilterOption[] = [
  { value: StatusFilter.All, label: 'All statuses' },
  { value: StatusFilter.Active, label: 'Active' },
  { value: StatusFilter.Available, label: 'Available' },
  { value: StatusFilter.Draft, label: 'Draft' },
];

export function StatusFilterMenu({
  value,
  counts,
  onChange,
  options = DEFAULT_STATUS_OPTIONS,
}: StatusFilterMenuProps) {
  const selectedOption = options.find(option => option.value === value);
  const triggerLabel = value === StatusFilter.All ? 'Status' : (selectedOption?.label ?? 'Status');
  const isFiltering = value !== StatusFilter.All;

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button type="button" className={styles.filterButton} data-active={isFiltering}>
          <ListFilter className={styles.filterIcon} />
          {triggerLabel}
          <ChevronDown className={styles.caret} />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className={styles.menu} align="start" sideOffset={8}>
          {options.map(option => (
            <Popover.Close
              key={option.value}
              type="button"
              className={styles.menuOption}
              data-selected={value === option.value}
              data-status={option.value}
              onClick={() => onChange(option.value)}>
              <span className={styles.optionDot} />
              {option.label}
              <span className={styles.optionMeta}>
                {counts[option.value]}
                {value === option.value && <Check className={styles.checkIcon} />}
              </span>
            </Popover.Close>
          ))}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
